export default __webpack_public_path__ + "static/media/musiswap-tagline.b1fa4c41.svg";